import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ExperienceSection from '../components/ExperienceSection';
import ProjectsSection from '../components/ProjectsSection';
import CodingStatsSection from '../components/CodingStatsSection';
import PassionSection from '../components/PassionSection';
import ContactSection from '../components/ContactSection';
import ParticleBackground from '../components/ParticleBackground';

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-white text-[#0a0a0a]">
      <ParticleBackground />
      <Header />
      <main className="relative">
        <HeroSection />
        <ExperienceSection />
        <ProjectsSection />
        <PassionSection />
        <CodingStatsSection />
        <ContactSection />
      </main>
    </div>
  );
};

export default Portfolio;
